import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-student-registration-form',
  templateUrl: './student-registration-form.component.html',
  styleUrls: ['./student-registration-form.component.scss']
})
export class StudentRegistrationFormComponent implements OnInit {

  registrationForm: FormGroup;
  
  submitRegistration: boolean = false;
  loader: boolean = false;
  // @Input() orgId: string | null = null;   
  // @Input() role: string | null = null;  

  @Output() closePopup = new EventEmitter<void>();
  @Output() userAdded = new EventEmitter<any>();


  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private ns: NotificationService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    this.registrationForm = this.formBuilder.group({
      first_name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern('^[a-zA-Z]*$')]],
      last_name: ['', [Validators.required,Validators.maxLength(100), Validators.pattern('^[a-zA-Z]*$')]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(280),Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      linkedin_url: ['', [Validators.required,Validators.pattern("^https:\/\/www\.linkedin\.com\/in\/.*")]],
    });
  }


  get userRegistration() { return this.registrationForm; }

  onRegister(): void {
    this.submitRegistration = true;

    if (this.registrationForm.invalid) {
      this.ns.showNotification('error', 'All fields are mandatory. Please correct the errors in the form.');
      return;
    }

    // Prepare payload from form
    let payload: any = { ...this.registrationForm.value };

    this.loader = true;
    this.userService.addOrgUser(payload)
      .pipe(finalize(() => {
        this.loader = false;
        this.submitRegistration = false;
      }))
      .subscribe(
        (response) => {
          this.ns.showNotification('success', 'Registration completed successfully.');
          this.userAdded.emit({ status: true, response });
          this.onClosePopup();
        },
        (error) => {
          this.ns.showNotification('error', (error && error.message) ? error.message : 'Something went wrong');
        }
      );
  }

  onClosePopup() {
    this.closePopup.emit();
  }
}
